import SvgIcon from '@home/components/SvgIcon';
import BubbleCommon from '@op/components/BubbleCommon';
import CardCommon from '@op/components/CardCommon';
import ChannelLabel from '@op/components/ChannelLabel';
import { DBO_V } from '@op/utils/format';
import { hashtagClickTitleTipsMap, hashtagDetailNoCategoryTipsMap } from '@opm/components/BubbleCommon';
import useIntls from '@opm/hooks/useIntls';
import CountryItem from '@opm/pages/Hashtag/components/CountryItem';
import HashtagAISummary from '@opm/pages/Hashtag/components/HashtagAISummary';
import MinChart from '@opm/pages/Hashtag/components/MinChart';
import moment from 'moment';
import React, { useMemo } from 'react';
import { Col, Row, Tag } from 'tea-component';

interface IHashtagInfoProps {
  data: any;
  loading: boolean;
  filter?: {
    hashtag?: string;
    time_range?: string;
    start_time?: string;
    end_time?: string;
    [key: string]: any;
  };
  translateCategory: (value: string, isEn: boolean) => string;
}

export default function HashtagInfo(props: IHashtagInfoProps) {
  const { data, loading, filter, translateCategory } = props;
  const { intl, isEn } = useIntls();

  const hashtagInfoData = useMemo(() => {
    return [
      { label: intl('Videos-2'), value: DBO_V.reviews(data?.tweets_posts) },
      { label: intl('Views'), value: DBO_V.reviews(data?.tweets_views) },
      {
        label: intl('Avg. Views / Video'),
        value: DBO_V.reviews(data?.tweets_views / data?.tweets_posts),
      },
      {
        label: (
          <BubbleCommon
            placement="top"
            showIcon={!data?.category}
            tipsMap={data?.category ? null : hashtagDetailNoCategoryTipsMap}
          >
            {intl('Category')}
          </BubbleCommon>
        ),
        component: (
          <span className="dbom-hashtag-info-category">
            {translateCategory(data?.category, isEn)}
          </span>
        ),
      },
      {
        label: intl('Country'),
        component: (
          <CountryItem
            country={data?.country}
            className="dbom-hashtag-info-country"
          ></CountryItem>
        ),
      },
      {
        label: intl('Trend'),
        component: <MinChart timeline={data?.trend}></MinChart>,
      },
    ];
  }, [data, intl, translateCategory]);
  return (
    <CardCommon
      loading={loading}
      loadingHeight={110}
      emptyHeight={110}
      className="dbom-hashtag-info"
      empty={!data || Object.keys(data).length === 0}
      hasEmptyImg={false}
    >
      <Header data={data} translateCategory={translateCategory} />
      {/* Hashtag AI Summary */}
      <HashtagAISummary
        filter={filter}
        className='dbom-hashtag-info-ai-summary-details-page'
      />
      <Row className="dbom-hashtag-info-content">
        {hashtagInfoData.map((item) => (
          <Col className="dbom-hashtag-info-col" key={item.label as string}>
            <span className="dbom-hashtag-info-label">{item.label}</span>
            <span className="dbom-hashtag-info-value">
              {item.component ?? item.value}
            </span>
          </Col>
        ))}
      </Row>
    </CardCommon>
  );
}

const Header = ({
  data,
  translateCategory,
}: {
  data: any;
  translateCategory: (value: string, isEn: boolean) => string;
}) => {
  const { hashtag, category, date, time_range: timeRange } = data;
  const { isEn } = useIntls();
  const dateRange = useMemo(() => {
    const endDate = moment(date, 'YYYY-MM-DD');
    let startDate = endDate.clone();

    if (timeRange === 'last_7_days') {
      startDate = endDate.clone().subtract(6, 'days'); // include today
    } else if (timeRange === 'last_30_days') {
      startDate = endDate.clone().subtract(29, 'days');
    }

    return `${startDate.format('YYYY-MM-DD')} ~ ${endDate.format(
      'YYYY-MM-DD',
    )}`;
  }, [date, timeRange]);

  return (
    <div className="dbom-hashtag-info-title">
      <div className="dbom-hashtag-info-title-left">
        <ChannelLabel channel_name={'tiktok'} showText={false} />
        <BubbleCommon
          placement="top"
          showIcon={false}
          tipsMap={hashtagClickTitleTipsMap}
          childClassName="dbom-hashtag-info-title-text"
        >
          <span onClick={() => window.open(`https://www.tiktok.com/tag/${hashtag.replace(/^#/, '')}`, '_blank')}>{hashtag}</span>
          <SvgIcon type="other-share-icon" />
        </BubbleCommon>
        {category && (
          <Tag className="dbom-hashtag-info-title-tag">
            {translateCategory(category, isEn)}
          </Tag>
        )}
        <span className="dbom-hashtag-info-title-date">{dateRange}</span>
      </div>
      {/* <div className="dbom-hashtag-info-title-right">
        <span className="dbom-hashtag-info-title-date">{dateRange}</span>
      </div> */}
    </div>
  );
};
